/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersResult } from '../../models/get-orders-result';

export interface GetOrders$Params {
  SiteName?: string;
  PageIndex?: number;
  PageSize?: number;
  RestaurantWithExternalOrderHistoryId?: number;
}

export function getOrders(
  http: HttpClient,
  rootUrl: string,
  params?: GetOrders$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetOrdersResult>> {
  const rb = new RequestBuilder(rootUrl, getOrders.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('RestaurantWithExternalOrderHistoryId', params.RestaurantWithExternalOrderHistoryId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersResult>;
    }),
  );
}

getOrders.PATH = '/Orders';
